import React from "react";
import localeMap from "locales/map";
import { getOrigin } from "utils/method";
import { buildSeoPagePath } from "utils/seoPath";

export default function Alternate({ resolvedUrl, locale, basePath }) {
  const domain = getOrigin("www");

  return (
    <>
      {localeMap.map((obj) => (
        <link
          key={obj.key}
          rel="alternate"
          href={domain + buildSeoPagePath(obj.name, resolvedUrl, basePath)}
          hrefLang={obj.name}
        />
      ))}
      <link
        rel="alternate"
        href={domain + buildSeoPagePath("en", resolvedUrl, basePath)}
        hrefLang="x-default"
      />
      <link rel="canonical" href={domain + buildSeoPagePath(locale, resolvedUrl, basePath)} />
    </>
  );
}
